import React from 'react';
import styled from 'styled-components';
import { Heading } from '../../ui/text/Heading';
import { Paragraph } from '../../ui/text/Paragraph';
import { Container } from '../../layout/Container';
import { Section } from '../../layout/Section';

const BoligutviklingClosed: React.FC = () => {
  return (
    <>
      <Container style={{ marginTop: '66px' }}>
        <Heading tag="h1" center={true} style={{ paddingTop: '2em' }}>
          Boligutvikling 2026
        </Heading>
        <TableWrapper>
          <Section>
            <Paragraph className="informasjon">
              Seminaret er nå fulltegnet.
            </Paragraph>
            <Paragraph className="informasjon">
              Send e-post til{' '}
              <a href="mailto:christina.lyngtveit@privatmegleren.no">
                christina.lyngtveit@privatmegleren.no
              </a>{' '}
              for å stå på venteliste, eller for å gi beskjed om at du likevel
              ikke kan delta slik at plassen din frigis.
            </Paragraph>
          </Section>
        </TableWrapper>
      </Container>
    </>
  );
};

const TableWrapper = styled.div`
  color: white;
  text-align: center;
  .table-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .row {
    display: flex;
  }

  .header-row {
    font-weight: bold;
  }

  .cell {
    flex: 1;
    padding: 10px;
    border: 1px solid #e7cfa7;
  }
  .informasjon {
    text-align: center;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .list {
    max-width: 500px;
    margin: 0 auto;
  }

  li {
    text-align: left;
  }

  tr {
    white-space: nowrap;
  }

  table {
    width: 100%;
  }

  th {
    padding-bottom: 11px;
    padding-left: 0;
  }
`;
export default BoligutviklingClosed;
